import { USERS_TAB } from "../../framework/tab/tabUtilsConstants";

export const initial_state_users = {
  type: USERS_TAB,
  label: "Users",
  allowMultipleTabs: false,
};
